<template>
  <div class="gift-history">
    <div class="history-sec">
      <h2>{{$t("gifthistory")}}</h2>
      <ul>
        <li v-for="(item, index) in giftHistory" :key="index">
          <div v-if="item.sender_phone_number == user.phone_number" class="call-mode-icon">
            <img src="../assets/images/sendcall_mod.svg" />
           </div>
          <div v-else-if="item.receiver_phone_number == user.phone_number" class="call-mode-icon call-received-icon">
             <img src="../assets/images/recievecall_mod.svg" />
           </div>
          <div class="gifthistory-details">
           {{item.sender_phone_number == user.phone_number ? item.receiver_phone_number : item.receiver_phone_number == user.phone_number ? item.sender_phone_number :'Not Available'}}
            <div class="gift-history-time">{{getLongFormattedDate(item.record_created_at, "en-IN")}}</div>
          </div>
          <div class="gifthistory-price">{{item.tiping_gold_amount}}gm</div>
        </li>
       </ul>
       <span v-if="!giftHistory.length" class="no-gifthistory">{{$t('no_history')}}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { toaster, getLongFormattedDate } from "../utils/helper";
export default {
  props:{
    giftHistory: {
      required: true,
      type: Array
    }
  },
  methods:{
    getLongFormattedDate
  },
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
